import { fetchWrapper } from "../utils/fetch-wrapper";

const ClientsService = {
  get_count_all,
  get_users_available,
  getAll,
  getByIdArcgis,
  getById,
  affectActifs,
  post,
  put,
  delete: _delete,
  archiver,
  activer,
};

function getAll() {
  return fetchWrapper.get("env_client/");
}
function get_count_all() {
  return fetchWrapper.get("env_client/CountEnv");
}

function getByIdArcgis(id_arcgis: string) {
  return fetchWrapper.get(`env_client/${id_arcgis}`);
}
function getById(id: number) {
  return fetchWrapper.get(`env_client/${id}`);
}

function get_users_available(id: number) {
  return fetchWrapper.get(`env_client/diagonline_users/${id}`);
}

function post(data: any) {
  return fetchWrapper.post("env_client/", data);
}

function _delete(id_arcgis: string) {
  return fetchWrapper.delete(`env_client/${id_arcgis}`);
}

function archiver(id_feature: string) {
  return fetchWrapper.put(`env_client/archiver/${id_feature}`, id_feature);
}
function activer(id_feature: string) {
  return fetchWrapper.put(`env_client/activer/${id_feature}`, id_feature);
}
function put(id: number, data: any) {
  return fetchWrapper.put(`env_client/${id}`, data);
}

function affectActifs(id: number, data: any) {
  return fetchWrapper.put(`env_client/actifs/${id}`, data);
}
export default ClientsService;
